var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "range-picker" },
    [
      _c("v-text-field", {
        attrs: {
          label: "Enter date range",
          "prepend-icon": "mdi-calendar",
          readonly: ""
        },
        model: {
          value: _vm.dateRangeText,
          callback: function($$v) {
            _vm.dateRangeText = $$v
          },
          expression: "dateRangeText"
        }
      }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { color: "primary", dark: "" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.dialog = true
            }
          }
        },
        [_c("v-icon", [_vm._v("mdi-reload")]), _vm._v(" Change dates")],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("v-date-picker", {
            attrs: { range: "", "first-day-of-week": 4, "picker-date": "" },
            model: {
              value: _vm.range,
              callback: function($$v) {
                _vm.range = $$v
              },
              expression: "range"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }